export default "__VITE_ASSET__I750vVaH__"